module.exports = "<p>\n  setup works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/app/setup/setup.component.html
// module id = ../../../../../src/app/setup/setup.component.html
// module chunks = main